import React from "react"
import {FieldQuickFilterViewProps} from "../../../render/quick-filter-view";

import PriorityIcon from "../../../../gd-components/priority/priority-icon/priority-icon";
import {QUICK_FILTER_ALL_VALUES} from "../../../../gd/const/quick-filter";


export default function FieldPriority_QuickFilterView(props: FieldQuickFilterViewProps) {

    let priority : any = parseInt(props.value)
    if (!priority) priority = null

    let icon = null
    let label = ''

    switch (props.value) {
        case QUICK_FILTER_ALL_VALUES:
            label = 'All priorities'
            break

        default:
            icon = <PriorityIcon className="icon" priority={priority}/>
            label = gd.company.priorities.getName(priority,true)
            break

    }

    return (
        <div className="ui5-group-by-view">
            {icon}
            <div className="name">{label}</div>
        </div>
    )

}